import { 
    SetVisningAction, 
    SET_VISNING, 
    ResultatValgVisning, 
    ResultatValgValidering, 
    UpdateValidationAction,
    UPDATE_VALIDERING
} from './Types';

export function setVisning(stegVisning: Partial<ResultatValgVisning>): SetVisningAction {
    return {
        type: SET_VISNING,
        payload: stegVisning,
    };
}

export function updateValidation(validation: Partial<ResultatValgValidering>): UpdateValidationAction {
    return {
        type: UPDATE_VALIDERING,
        payload: validation,
    };
}
